import React from "react";
import { Button } from "@mui/material";
import colors from "../../../../../utils/colors";

const PrimaryButton = ({ children, startIcon, onClick, disabled, ...props }) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      sx={{
        height: 36,
        borderRadius: "8px",
        backgroundColor: "#6371F7",
        border: "1px solid #6371F7",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: "21px",
        textTransform: "none",
        color: "#FFFFFF",
        px: 4,
        "&:hover": {
          backgroundColor: "#4959ee",
          borderColor: "#4959ee",
        },
        "&:disabled": {
          backgroundColor: colors.neutral[200],
          borderColor: colors.neutral[200],
          color: colors.neutral[500],
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
